import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  TextField,
} from "@mui/material";
import { useAuth } from "../../../auth/auth";
import styles from "./GenerateWeeklyHours.module.css";
import { generateWorkHoursReport, getAllClients, getProjectsByCompany } from "../../../api/apiCall";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useUKRailWeek } from "../../../hooks/useUKRailWeek";

const GenerateWeeklyHours = () => {
  const { state } = useAuth();
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState<any>([]);
  const [projects, setProjects] = useState<any>([]);
  const {currentWeek, currentYear} = useUKRailWeek();

  const { register, handleSubmit, control, watch } = useForm<any>({
    defaultValues: {
      week: currentWeek,
      year: currentYear,
      clientId: "",
      projectId: "",
    },
  });

  const watchFields = watch();

  const getClients = async () => {
    const response = await getAllClients(state.user?.token);
    if (response) {
      setClients(response);
    }
  };

  const onSubmit = async (data: any) => {
    setLoading(true);
    const response = await generateWorkHoursReport(state.user?.token, data);
    if (response?.status === 200) {
      setLoading(false);
    } else {
      setLoading(false);
      toast.error("Something went wrong!");
    }
  };

  const getProjects = async () => {
    const response = await getProjectsByCompany(state.user?.token, watchFields.clientId?.id);
    console.log(response)
    setProjects(response?.data)
  }

  useEffect(() => {
    getClients();
  }, []);

  useEffect(() => {
    getProjects();
  }, [watchFields.clientId]);

  return (
    <>
      <div className={styles.formContainer}>
        <div className={styles.timesheetForm}>
          <Box>
            <div className={styles.timesheetFormDiv}>
              <h2 className={styles.timesheetTitle}>Hourly Report</h2>
              <p className={styles.timesheetSubtitle}>
                Generate Hourly Report for Week
              </p>
              <TextField
                variant="outlined"
                label="Week"
                placeholder="Enter Week"
                className={styles.exportButton}
                style={{ margin: 15 }}
                {...register("week")}
              />
              <TextField
                variant="outlined"
                label="Year"
                placeholder="Enter Year"
                className={styles.exportButton}
                style={{ margin: 15 }}
                {...register("year")}
              />
              <Controller
                name="clientId"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    options={clients}
                    getOptionLabel={(option: any) => option.companyName || ""}
                    isOptionEqualToValue={(option: any, value: any) =>
                      option.companyName === value?.companyName
                    }
                    style={{ margin: 15 }}
                    value={field.value || null}
                    onChange={(_, value) => field.onChange(value)}
                    clearOnEscape
                    ListboxProps={{
                      style: {
                        maxHeight: 320,
                        overflow: "auto",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Client"
                        placeholder="Choose a Client"
                        size="medium"
                        sx={{ width: "400px" }}
                      />
                    )}
                  />
                )}
              />
              {Array.isArray(projects) && projects.length > 0 && 
                <Controller
                  name="projectId"
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      options={projects}
                      getOptionLabel={(option: any) => `(${option.workerCount ?? 0}) - ${option.projectName || ""} `}
                      isOptionEqualToValue={(option: any, value: any) =>
                        option.projectName === value?.projectName
                      }
                      style={{ margin: 15 }}
                      value={field.value || null}
                      onChange={(_, value) => field.onChange(value)}
                      clearOnEscape
                      ListboxProps={{
                        style: {
                          maxHeight: 320,
                          overflow: "auto",
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Project"
                          placeholder="Choose a project"
                          size="medium"
                          sx={{ width: "400px" }}
                        />
                      )}
                    />
                  )}
                />
              }
              <Button
                variant="contained"
                disabled={loading}
                size="medium"
                style={{
                  boxShadow: "none",
                  marginTop: 25,
                  backgroundColor: "#1976d2",
                  color: "white",
                }}
                className={styles.exportButton}
                onClick={handleSubmit(onSubmit)}
              >
                {loading ? 
                  <CircularProgress size={25} style={{ color: "white" }} />
                :
                  "Export Weekly Hours"
                }
              </Button>
              <div
                style={{ textAlign: "center", margin: 4, marginBottom: -10 }}
              >
                {loading && "This might take a while"}
              </div>
            </div>
          </Box>
        </div>
      </div>
    </>
  );
};

export default GenerateWeeklyHours;
